module.exports = __webpack_public_path__ + "media/images/vector-37@2x-c038419bc9c2b979e4a8be6c62476f2c.png";